import { useClient } from '@composables/use-clients';
import { GetRequestArgsType } from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type GetTenantUserTeamTenantUsersArgsType = GetRequestArgsType & {
  tenantUserId: number;
};

export const apiFetchTenantUserTeamTenantUsers = async ({
  domain = useTenantStore().domain,
  tenantUserId,
  query,
  errorConfig = {},
  callbacks = {},
}: GetTenantUserTeamTenantUsersArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.tenantUserTeamTenantUsers({ domain, tenantUserId }),
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
